<template>
  <form-edit-activity :form-type="FORM_TYPE" ref="formEditor"
                      :mode="mode"
                      :entity-id="entityId"
                      @form-created="formCreated"
                      :show-footer-navbar="showMainFooterNavbar"
                      @click-on-info="clickOnMainTab"
  >
    <template v-slot:custom-details>
      <b-tab v-for="detailName in details" :key="detailName" :title="detailName" @click="clickOnListTab(detailName)">
        <forms-list-activity
            :ref="'list-' + detailName"
            v-if="readyToLoad"
            :form-type=FORM_DETAILS_TYPE
            :show-add="false"
            :show-delete="false"
            :custom-data-loader="() => dataLoader(detailName)"
            :column-mixins="columnMixins"
            :show-details="false"
        >
        </forms-list-activity>
      </b-tab>
    </template>

  </form-edit-activity>
</template>

<script>
import Activity from "@/activity/Activity";
import PermissionsSet from "@/server/PermissionsSet";
import Rpc from "@/Rpc";
import FormsListActivity from "@/activity/templates/layouts/forms/FormsListActivity";
import FormsLoader from "@/components/forms/FormsLoader";

import FormEditActivity from "@/activity/templates/layouts/forms/FormEditActivity";
import FormMixin from "@/components/forms/customizations/mixins/FormMixin";
import ReachInput from "@/components/inputs/ReachInput";
import ProductGrading from "@/server/com/silkplm/model/plm/dictionaries/ProductGrading";
import SizeForProductGrading from "@/server/com/silkplm/model/plm/SizeForProductGrading";
import Size from "@/server/com/silkplm/model/plm/dictionaries/Size";
import ProductGradingDetail from "@/server/com/silkplm/model/plm/dictionaries/ProductGradingDetail";
import ConstructionPointForProductGrading from "@/server/com/silkplm/model/plm/ConstructionPointForProductGrading";
import ColumnMixin from "@/components/forms/customizations/mixins/ColumnMixin";
import MixinValueGrid from "@/components/datagrid/MixinValueGrid";
import GridCellEditor from "@/components/forms/GridCellEditor";


const FORM_TYPE = ProductGrading;
const FORM_DETAILS_TYPE = ProductGradingDetail;

export default {
  name: "ProductGrading",
  components: {ReachInput, FormMixin, FormEditActivity, FormsListActivity},
  permission: () => FormsLoader.formPermission(FORM_TYPE),

  props: {
    entityId: {default: null},
    mode: {type: String, default: "NEW"},
    context: {default: null}
  },

  created() {
  },

  async mounted() {
    await this.findExtensionNameBySizeGroupName();
    this.$onChange(ConstructionPointForProductGrading, async (changeEvent) => {
      if (changeEvent.instance?.productGradingId === this.entityId || !changeEvent.instance) {
        await this.findExtensionNameBySizeGroupName();
      }
    });
    this.$onChange(SizeForProductGrading, async (changeEvent) => {
      if (changeEvent.instance?.productGradingId === this.entityId || !changeEvent.instance) {
        await this.findExtensionNameBySizeGroupName();
      }
    });
    this.$onChange(ProductGradingDetail, async (changeEvent) => {
      if (changeEvent.instance && (changeEvent.instance?.productGradingId === this.entityId || !changeEvent.instance)) {
        if (this.detailsName && this.$refs["list-" + this.detailsName][0]?.$refs) {
          this.$refs["list-" + this.detailsName][0].$refs.entititesList.lists = [];
          this.$refs["list-" + this.detailsName][0].$refs.entititesList.list = [];
          let entities = await this.loadData(changeEvent.instance.sizeGroupName);
          this.$refs["list-" + this.detailsName][0].$refs.entititesList.lists = entities;
          this.$refs["list-" + this.detailsName][0].$refs.entititesList.list = entities;
        }
      }
    });
  },

  methods: {
    ...Activity.methods,

    async canClose() {
      return this.$refs.formEditor.canClose();
    },

    /** @type {FormModel} form */
    async formCreated(form) {

      this.form = form;
    },

    async clickOnListTab(detailsName) {
      this.showMainFooterNavbar = false;
      this.selectedSizeGroupName = detailsName;
      await this.findMixinsColumns(detailsName);
      this.detailsName = detailsName;
    },

    clickOnMainTab() {
      this.showMainFooterNavbar = true;
    },

    async findExtensionNameBySizeGroupName() {
      if (this.mode === "NEW") {
        return;
      }
      this.details = await Rpc.plm.services.DimensionalService.findDetailsForProductGrading(this.entityId);
    },

    async loadData(detailName) {

      if (this.detailsName !== detailName) {
        return;
      }
      let entities = await Rpc.plm.services.DimensionalService.listProductGradingDetailForSizeGroupName(this.entityId, detailName);
      let results = await Rpc.plm.services.DimensionalService.calculateProductGradingAlgorithmForAllEntities(entities, this.sizeForProductGradingListMatchedWithTab);
      for (let index = 0; index < entities.length; index++) {
        let entity = entities[index];
        let arr = results[index];
        for (let index = 0; index < this.columnMixins.length; index++) {
          let columnMixin = this.columnMixins[index];
          entity["__" + columnMixin.column.name] = arr[columnMixin.column.name];
        }
      }
      return entities;
    },

    async findMixinsColumns(sizeGroupName) {

      this.readyToLoad = false; // bez tego metoda data load się nie wywołuje
      let columnMixins = [];
      let data = await Rpc.plm.services.DimensionalService.loadDataForProductGradingDetail(this.entityId, sizeGroupName);

      this.sizeForProductGradingListMatchedWithTab = data.sizeForProductGradingsDetailsList;

      let order = 100000;
      let index = 0;
      for (let size of data.sizeList) {
        let mixinCol = new ColumnMixin('attachments', { // na nieistniejącej kolumnie spowoduje, że trafi na koniec
          name: size.name, prop: "__" + size.name, template: MixinValueGrid, isDynamicCell: true
        });
        columnMixins.push(mixinCol);
        index++;
      }
      columnMixins = columnMixins.reverse();
      this.columnMixins = columnMixins;
      this.readyToLoad = true;
    }
  },

  data: function () {
    const that = this;
    return {
      dataLoader: function (...args) {
        return that.loadData(...args);
      },
      FORM_TYPE,
      FORM_DETAILS_TYPE,
      /** @type {FormModel} */
      form: null,
      readOnly: true,
      permissions: new PermissionsSet(),
      formConfig: FormsLoader.detectFormConfig(FORM_TYPE),
      detailsFormConfig: FormsLoader.detectFormConfig(FORM_DETAILS_TYPE),
      formId: FormsLoader.detectFormConfig(FORM_TYPE).formId,
      details: [],
      showMainFooterNavbar: true,
      selectedSizeGroupName: null,
      columnMixins: [],
      sizeListMatchedWithTab: [],
      sizeForProductGradingListMatchedWithTab: [],
      detailsName: "",
      readyToLoad: false,
    }
  }
}
</script>
